var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carroussel-header'),_c('tech-consulting'),_c('fintech'),_c('payment-integration'),_c('section',{staticClass:"section section-lg section-shaped overflow-hidden my-0"},[_vm._m(0),_c('contact')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shape shape-style-3 shape-default shape-skew"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }